import API_ENDPOINTS from "../config/apiEndpoints";
import { ensureOk, parseJsonSafe, requestWithAuth } from "./apiClient";

export const apiInformesPeriodicosService = {
  getByEmpresa: async (empresaId) => {
    const response = await requestWithAuth(API_ENDPOINTS.INFORMES_PERIODICOS.BY_EMPRESA(empresaId), {
      method: "GET",
    });
    ensureOk(response, "No se pudieron cargar los informes configurados.");
    const data = await parseJsonSafe(response);
    return Array.isArray(data) ? data : [];
  },

  create: async (payload) => {
    const response = await requestWithAuth(API_ENDPOINTS.INFORMES_PERIODICOS.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    ensureOk(response, "No se pudo guardar la configuracion.");
    return parseJsonSafe(response);
  },

  remove: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.INFORMES_PERIODICOS.DELETE(id), {
      method: "DELETE",
    });
    ensureOk(response, "No se pudo eliminar la configuracion.");
    return parseJsonSafe(response);
  },
};
